// Fancybox
(function ($) {
	$(document).ready(function () {
		$(".fancybox-media").fancybox({
			openEffect: "none",
			closeEffect: "none",
			helpers: {
				media: {},
			},
		});
	});
	$(document).ready(function () {
		$('[data-fancybox="gallery"]').fancybox({
			baseClass: "fancybox-custom-layout",
			infobar: false,
			touch: {
				vertical: false,
			},
			buttons: ["thumbs", "close"],
			preventCaptionOverlap: false,
			idleTime: false,
			gutter: 0,
		});
	});
})(jQuery);
